import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import queryString from 'query-string';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../actions/identification.actions';
import {patchAuthenticationConfig} from '../../../actions/user.actions';
import Button from '../../Common/Button';
import ButtonGroup from '../../Common/ButtonGroup';
import {PageContainer, PageTitle} from '../../Common/PageComponents';
import PageDescription from '../../Common/PageDescription';
import Table from '../../Common/Table';

const stateToProps = state => {
  return {
    identification: state.identification,
    user: state.user,
  };
};

class AuthenticationConfig extends Component {
  constructor() {
    super();
    this.state = {
      useIdentityVerificationOnIpManagement: undefined,
    };
  }

  componentDidMount() {
    let requestParams = queryString.parse(window.location.search);
    this.props.dispatch(
      fetchIdentificationWithRequestTokenOrRedirectOnFail(
        requestParams.identityToken,
        '/my-pc-bang/authentication-config/identification',
        this.props.history,
        '',
        this.props.user.duplicationInformation
      )
    );

    if (this.props.user.useIdentityVerificationOnIpManagement !== undefined) {
      this.setState({
        useIdentityVerificationOnIpManagement: this.props.user.useIdentityVerificationOnIpManagement,
      });
    }
  }

  _onUseIdentityVerificationOnIpManagementChanged(e) {
    this.setState({
      useIdentityVerificationOnIpManagement: e.target.value,
    });
  }

  _saveSettings(e) {
    e.preventDefault();

    this.props.dispatch(patchAuthenticationConfig(this.state.useIdentityVerificationOnIpManagement));
  }

  render() {
    if (!this.props.identification) {
      return null;
    }

    return (
      <PageContainer>
        <PageTitle title="보안관리" data-qa="usagePageTitle">
          Home &gt; MY PC방 &gt; <strong>보안관리</strong>
        </PageTitle>
        <PageDescription>
          본 페이지는 리그 오브 레전드 PC방 업주의 권익 보호를 위한 보안 설정 페이지입니다.
          <br />
          해당 기능을 적극 활용하여 주시기 바랍니다.
        </PageDescription>
        <form ref={form => (this.form = form)}>
          <Table theme="form">
            <colgroup>
              <col style={{width: 312}} />
              <col style={{width: 438}} />
            </colgroup>
            <thead>
              <tr>
                <th>메뉴명</th>
                <th>적용유무</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PC방 관리 &gt; IP 관리</td>
                <td className="left">
                  <span>
                    <input
                      type="radio"
                      name="useIdentityVerificationOnIpManagement"
                      id="ipCerityfyPersonalYN1"
                      value={true}
                      defaultChecked={this.props.user.useIdentityVerificationOnIpManagement === true}
                      onChange={e => this._onUseIdentityVerificationOnIpManagementChanged(e)}
                    />
                    <label htmlFor="ipCerityfyPersonalYN1">본인인증 기능 적용</label>
                  </span>
                  <span style={{marginLeft: '20px'}}>
                    <input
                      type="radio"
                      name="useIdentityVerificationOnIpManagement"
                      id="ipCerityfyPersonalYN2"
                      value={false}
                      defaultChecked={this.props.user.useIdentityVerificationOnIpManagement === false}
                      onChange={e => this._onUseIdentityVerificationOnIpManagementChanged(e)}
                    />
                    <label htmlFor="ipCerityfyPersonalYN2">본인인증 기능 적용 해제</label>
                  </span>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Button onClick={e => this._saveSettings(e)}>저장</Button>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect(stateToProps)(AuthenticationConfig));
